import { render, staticRenderFns } from "./CalendarEventHandler.vue?vue&type=template&id=3d7e9f59&"
import script from "./CalendarEventHandler.vue?vue&type=script&lang=js&"
export * from "./CalendarEventHandler.vue?vue&type=script&lang=js&"
import style0 from "./CalendarEventHandler.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports